export function objectEquals(obj1: any, obj2: any): boolean {
  // if both x and y are null or undefined and exactly the same
  if (obj1 === obj2) {
    return true;
  }

  // if they are not strictly equal, they both need to be Objects
  if (!(obj1 instanceof Object) || !(obj2 instanceof Object)) {
    return false;
  }

  // they must have the exact same prototype chain, the closest we can do is
  // test there constructor.
  if (obj1.constructor !== obj2.constructor) {
    return false;
  }

  for (const p in obj1) {
    // other properties were tested using x.constructor === y.constructor
    if (!obj1.hasOwnProperty(p)) {
      continue;
    }

    // allows to compare x[p] and y[p] when set to undefined
    if (!obj2.hasOwnProperty(p)) {
      return false;
    }

    // if they have the same strict value or identity then they are equal
    if (obj1[p] === obj2[p]) {
      continue;
    }

    // Numbers, Strings, Functions, Booleans must be strictly equal
    if (typeof obj1[p] !== 'object') {
      return false;
    }

    // Objects and Arrays must be tested recursively
    if (!objectEquals(obj1[p], obj2[p])) {
      return false;
    }
  }

  for (const p in obj2) {
    // allows x[p] to be set to undefined
    if (obj2.hasOwnProperty(p) && !obj1.hasOwnProperty(p)) {
      return false;
    }
  }

  return true;
}

export function getProperty(obj: any, path: string): any {
  if (!path || !obj) {
    return null;
  }

  return path
    .split('.')
    .reduce((result, prop) => (result == null ? undefined : result[prop]), obj);
}
